module.exports = __webpack_public_path__ + "media/images/favicons/safari-pinned-tab-21e4f3f31074d690116d1ed5c42a5be3.svg";